/* ==========================================================================
   faq-groups.js — FAQ page section: search + topic filter
   Ported from the mockup's initFaq(). Filters the questions by topic chip and
   by the words typed in the search box, updates the count, shows the
   "no answer" message, and opens the question named in the URL hash.
   ========================================================================== */
(() => {
  'use strict';
  const ZC = window.ZC;
  if (!ZC) return;
  const { $, $$ } = ZC;

  ZC.mount((root) => {
    $$('[data-faq-section]', root).forEach((section) => {
      if (!ZC.once(section, 'faq-groups')) return;
      const items = $$('[data-faq-item]', section);
      if (!items.length) return;
      const groups = $$('[data-faq-group]', section);
      const chips = $$('[data-faq-cat]', section);
      const search = $('[data-faq-search]', section);
      const form = $('[data-faq-form]', section);
      const count = $('[data-faq-count]', section);
      const none = $('[data-faq-none]', section);
      let cat = 'all';

      const norm = (t) => t.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
      const apply = () => {
        const q = norm(search ? search.value.trim() : '');
        let n = 0;
        items.forEach((it) => {
          const show = (cat === 'all' || it.dataset.cat === cat) && (!q || norm(it.textContent).includes(q));
          it.hidden = !show;
          if (show) n += 1;
        });
        groups.forEach((g) => { g.hidden = !$$('[data-faq-item]:not([hidden])', g).length; });
        chips.forEach((b) => {
          const on = b.dataset.faqCat === cat;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', String(on));
        });
        if (count) count.textContent = String(n);
        if (none) none.hidden = n > 0;
        const opened = q && n > 0 && n <= 3;
        items.forEach((it) => {
          if (opened && !it.hidden) it.setAttribute('open', '');
          else if (!q) it.removeAttribute('open');
        });
      };

      chips.forEach((b) => b.addEventListener('click', () => { cat = b.dataset.faqCat; apply(); }));
      if (search) search.addEventListener('input', apply);
      if (form) form.addEventListener('submit', (e) => e.preventDefault());

      // open the question named in the URL hash, if any
      const h = location.hash && document.getElementById(location.hash.slice(1));
      if (h && section.contains(h)) {
        const d = h.matches('details') ? h : $('details', h);
        if (d) d.setAttribute('open', '');
      }
    });
  });
})();
